let cookieContainer = null;
let container = null;
let cookieContainerSettings = null;
let documentBody = null;

$(document).ready(function () {

    documentBody = $('body');
    container = $('#c3kieContainerSettings');
    cookieContainer = $('.cookie-container');
    cookieContainerSettings = $('.cookie-container-settings');

    checkCookieLifetime();

    showCookieWindow();

    setCookieHeight();

    /**
     * cookies revoked
     */
    $('.cookie-outer-container-wrap .revoke').click(function () {
        setC3kieOptIn('revoke');
        cookieContainerSettings.find('.cookie-option').each(function () {
            localStorage.removeItem('c3kie_' + $(this).data('name'));
        })
        cookieContainerSettings.hide();
        cookieContainer.hide();
        submitCookieSettings();
        reload();
    });

    /**
     * load cookies after button accept
     */
    $('.cookie-outer-container-wrap .accept-all').click(function () {
        setC3kieOptIn('accept-all');
        cookieContainerSettings.find('.cookie-option').each(function () {
            localStorage.setItem('c3kie_' + $(this).data('name'), 'true');
        })
        cookieContainerSettings.hide();
        cookieContainer.hide();
        preSelectSettings();
        loadCookieScripts();
        submitCookieSettings();
        reload();
    });

    /**
     * load cookies - show only hint
     */
    $('.cookie-outer-container-wrap .notice').click(function () {
        setC3kieOptIn('notice');
        cookieContainer.hide();
    });
    if ($('.cookie-container.optin_0').length && localStorage.getItem('cookie_optin') !== 'true') {
        localStorage.setItem('cookie_optin', 'true');
        cookieContainerSettings.find('.cookie-option').each(function () {
            localStorage.setItem('c3kie_' + $(this).data('name'), 'true');
        })
    }

    /**
     * save cookie settings
     */
    $('.cookie-outer-container-wrap .save-settings').click(function () {
        cookieContainerSettings.hide();
        cookieContainer.hide();
        if (checkCookieLifetime()) {
            eraseCookie(checkCookieLifetime());
        }
        setC3kieOptIn('save-settings');
        cookieContainerSettings.find('.cookie-option').each(function () {
            localStorage.removeItem('c3kie_' + $(this).data('name'));
            if ($(this).is(':checked')) {
                localStorage.setItem('c3kie_' + $(this).data('name'), 'true');
            }
        })
        loadCookieScripts();
        submitCookieSettings();
        reload();
    });

    preSelectSettings();

    placeCookieSettings();

    loadCookieScripts();

    analyze();

    /**
     * open cookie settings
     */
    $('.cookie-outer-container-wrap .settings').click(function () {
        cookieContainerSettings.show();
    });

    /**
     * edit cookie settings - privacy page
     */
    $('.cookie-settings-button').click(function () {
        preSelectSettings();
        cookieContainerSettings.show();
    });

    /**
     * close cookie option window
     */
    cookieContainerSettings.click(function (e) {
        if (!$(this).parents('.cookie-container-popup').length && $(e.target)[0].className === 'inner-cookie-container-settings') {
            cookieContainerSettings.hide();
        }
    });

    /**
     * close / show cookie description window
     */
    $('.cookie-description-container-open').click(function () {
        $('.cookie-description-container').show();
    })
    $('.cookie-description-container-window-inner-close').click(function () {
        $('.cookie-description-container').hide();
    })

    /**
     * youtube-video-disclaimer
     */
    let youtubePlayButton = $('.youtube-activate-button');
    if (youtubePlayButton !== undefined && youtubePlayButton.length) {

        youtubePlayButton.unbind('click');
        youtubePlayButton.click(function () {

            convertIntoYoutubeElement($(this), 1);

        });

        /**
         * automatic remove youtube-video-disclaimer if opt-in accepted
         */
        if (localStorage.getItem('c3kie_youtube') === 'true') {
            youtubePlayButton.each(function () {
                convertIntoYoutubeElement($(this), 0)
            })
        }
    }

});

$(window).resize(function () {
    setCookieHeight();
});

function reload() {
    location.reload();
}


function convertIntoYoutubeElement(element, autoplay) {

    const parentElement = element.parent();
    const mainElement = parentElement.parent();
    const imgElement = parentElement.find('.preview-image');

    let width = Math.round( imgElement.data('width') ?? mainElement.width() );
    let height = Math.round( imgElement.data('height') ?? mainElement.height() );
    let youtube_src = element.data('youtube-src');
    let uid = element.data('uid');

    const videoElement = $('<iframe id="youtube-video-' + uid + '" class="youtube-video" width="' + width + '" height="' + height + '"\n' + 'src="https://www.youtube-nocookie.com/embed/' + youtube_src + '?enablejsapi=1&autoplay=' + autoplay + '&rel=0&modestbranding=1"\n' + ' allowfullscreen allow="autoplay; encrypted-media"></iframe>');

    mainElement.append(videoElement);
    parentElement.remove();

}

/**
 * load cookies on page load
 */
function loadCookieScripts() {

    let valuesArray = [];

    container.find('[type="checkbox"]:checked').each(function (key, value) {
        valuesArray.push($(value).data('name'));
    })

    container.find('#values').val(valuesArray.toString());

    let values = container.find('#values').val();
    let action = container.attr('action');
    let [_, rawParams] = action.split('?');
    let params = new URLSearchParams(rawParams);

    let newParams = new URLSearchParams();
    if (params.get('id')) {
        newParams.append('id', params.get('id'));
    }
    newParams.append('type', params.get('type'));
    newParams.append('tx_c3cookie_ajax[controller]', 'Ajax');
    newParams.append('tx_c3cookie_ajax[action]', 'cookieScriptContainer');
    newParams.append('cHash', params.get('cHash'));

    $.ajax({
        method: "POST", url: `/?${newParams}`, data: {
            'tx_c3cookie_ajax[values]': values
        }
    })
        .done(function (msg) {
            $('head').append(msg);
        });
}

function submitCookieSettings() {

    let values = {}

    values['cookies'] = {}

    if (navigator.language)
        values['browser_language'] = navigator.language;
    if (document.querySelector('#cookie-fe-language'))
        values['website_language'] = document.querySelector('#cookie-fe-language').value;

    container.find('[type="checkbox"]:checked').each(function (key, value) {
        values['cookies'][$(value).data("name")] = 1
    })

    $.ajax({
        method: "POST", url: "/?type=1613380", data: {
            "tx_c3cookie_ajax[controller]": 'Ajax',
            "tx_c3cookie_ajax[action]": 'cookieSubmit',
            "tx_c3cookie_ajax[values]": JSON.stringify(values)
        }
    })
        .done(function (msg) {
            //console.log('submitted');
        });
}

function analyze() {

    let values = {}

    if (navigator.language)
        values['browser_language'] = navigator.language;
    if (document.querySelector('#cookie-fe-language'))
        values['website_language'] = document.querySelector('#cookie-fe-language').value;

    values['browser'] = {};
    values['browser']['userAgent'] = ((navigator.userAgent) ? navigator.userAgent : '');
    values['browser']['cookieEnabled'] = ((navigator.cookieEnabled) ? navigator.cookieEnabled : '');
    values['browser']['maxTouchPoints'] = ((navigator.maxTouchPoints) ? navigator.maxTouchPoints : '');

    values['device'] = {};
    values['device']['innerWidth'] = ((window.innerWidth) ? window.innerWidth : '');
    values['device']['innerHeight'] = ((window.innerHeight) ? window.innerHeight : '');
    values['device']['outerWidth'] = ((window.outerWidth) ? window.outerWidth : '');
    values['device']['outerHeight'] = ((window.outerHeight) ? window.outerHeight : '');
    values['device']['devicePixelRatio'] = ((window.devicePixelRatio) ? window.devicePixelRatio : '');

    values['info'] = {};
    values['info']['url'] = ((window.location.href) ? window.location.href : '');
    values['info']['referrer'] = ((document.referrer) ? document.referrer : '');

    if (
        sessionStorage.getItem('c3kieHash') === 'false' ||
        sessionStorage.getItem('c3kieHash') == null ||
        sessionStorage.getItem('c3kieHash') === undefined
    ) {
        sessionStorage.setItem('c3kieHash', createRandomString(64));
    }
    values['info']['hash'] = sessionStorage.getItem('c3kieHash');

    values['cookies'] = {}
    container.find('[type="checkbox"]:checked').each(function (key, value) {
        values['cookies'][$(value).data("name")] = 1
    })


    let action = container.data('tracking');
    let [_, rawParams] = action.split('?');
    let params = new URLSearchParams(rawParams);

    let newParams = new URLSearchParams();
    if (params.get('id')) {
        newParams.append('id', params.get('id'));
    }
    newParams.append('type', params.get('type'));
    newParams.append('tx_c3cookie_ajax[controller]', 'Ajax');
    newParams.append('tx_c3cookie_ajax[action]', 'analyze');
    newParams.append('cHash', params.get('cHash'));

    $.ajax({
        method: "POST", url: `/?${newParams}`, data: {
            "tx_c3cookie_ajax[values]": JSON.stringify(values)
        }
    })
        .done(function (msg) {
            //console.log('submitted');
        });
}

function setCookieHeight() {
    if (cookieContainer != null) {
        if (cookieContainer.hasClass('top') || cookieContainer.hasClass('bottom')) {
            if (cookieContainer.hasClass('bottom')) {
                documentBody.css('paddingBottom', cookieContainer.outerHeight() + 'px');
            }
            if (cookieContainer.hasClass('top')) {
                if (cookieContainer.css('position') === 'fixed') {
                    documentBody.css('paddingTop', '0');
                } else {
                    documentBody.css('paddingTop', cookieContainer.outerHeight() + 'px');
                }
            }
        }
    }
}

/**
 * set checkboxes on user input
 * preselect in settings window
 */
function preSelectSettings() {

    cookieContainerSettings.find('.cookie-option').each(function () {
        if (localStorage.getItem('c3kie_' + $(this).data('name')) === 'true') {
            $(this).prop("checked", true);
        }
    })

}

/**
 * display the cookie window
 */
function showCookieWindow() {
    if (
        !checkCookieLifetime()
    ) {
        cookieContainer.show();
        let popup = $('.cookie-outer-container-wrap.popup');
        if (popup.length && !popup.hasClass('.privacy-page')) {
            popup.find('.cookie-container-settings').show();
        }
    } else {
        cookieContainer.hide();
    }
}

/**
 * place cookie settings button on privacy page
 */
function placeCookieSettings() {
    let main = $('body > main').first(), content = $('body > .content').first(),
        customSettingsBox = $('.c3kie-custom-cookie-settings-position');

    if (customSettingsBox.length) {

        placeCookieButton(customSettingsBox);

    } else {

        if (main.length) {
            placeCookieButton(main);
        } else if (content.length) {
            placeCookieButton(content);
        }
        $('.cookie-settings-default-button').show();

    }
}

/**
 * append edit cookie button into an element
 * @param elem
 */
function placeCookieButton(elem) {
    elem.append($('.cookie-outer-container-wrap'));
}

/**
 * create hash value
 * @param length
 * @returns {string}
 */
function createRandomString(length) {
    let result = '';
    const characters = '#ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

/**
 * which action was performed
 * @param value
 */
function setC3kieOptIn(value) {
    setCookie('c3kie',value,'180');
}

function checkCookieLifetime() {
    let c3kie = getCookie('c3kie');
    if (
        c3kie === null
    ) {
        cookieContainerSettings.find('.cookie-option').each(function () {
            localStorage.removeItem('c3kie_' + $(this).data('name'));
        })
        return false;
    }
    return c3kie
}

/**
 * create cookie
 * @param name
 * @param value
 * @param days
 */
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + ";secure; path=/";
}

/**
 * read cookie
 * @param name
 * @returns {null|string}
 */
function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

/**
 * remove cookie
 * @param name
 */
function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}